import { MILESTONE } from "../../content/site";

export const MilestoneStat = ({ tone = "light", className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`} data-testid="milestone-stat">
    <span className={`font-display whitespace-nowrap text-4xl md:text-5xl font-medium tracking-tight ${tone === "light" ? "text-[#74DC26]" : "text-[#082619]"}`}>
      <span className="font-serif-i mr-2 text-2xl md:text-3xl align-middle">~</span>{MILESTONE.value}
      <span className="ml-1 text-xl md:text-2xl">{MILESTONE.unit}</span>
    </span>
    <span className={`max-w-[11rem] text-sm leading-snug ${tone === "light" ? "text-[#E6EDE8]" : "text-[#4C6053]"}`}>
      {MILESTONE.prefix} {MILESTONE.value} {MILESTONE.unit} {MILESTONE.label}
    </span>
  </div>
);
